import styled from 'styled-components'

export const Wrapper = styled.div`
  background : ${props => props.background};
  padding : ${props => props.padding || "20px 0"};
`
